<template>
  <popup @click-overlay="clickOverlay" v-model="showDetails">
    <div class="camilo-details">
      <div class="title">
        <div class="icon">
          <img v-lazy="ticketDetails.pic_url" />
        </div>
        <div class="intro">
          <div class="name">{{ticketDetails.name}}</div>
        </div>
      </div>
      <div class="details" v-if="ticketDetails.content">
        <template v-if="ticketDetails.content.card_verify">
          <div class="list">
            <div class="kami">
              <div class="kami-desc">
                <div class="intro">
                  <span>校验码:</span>
                  <em>{{ticketDetails.content.card_verify}}</em>
                </div>
                <button
                  :data-clipboard-text="ticketDetails.content.card_verify"
                  @click="getCardsClose"
                  class="copy cards-close"
                >复制</button>
              </div>
              <div class="kami-desc">
                <div class="intro">
                  <span>卡密:</span>
                  <em>{{ticketDetails.content.card_pwd}}</em>
                </div>
                <button
                  :data-clipboard-text="ticketDetails.content.card_pwd"
                  @click="getCardsClose"
                  class="copy cards-close"
                >复制</button>
              </div>
              <div class="show-code-button">
                <div class="show-qr-code">
                  <img alt src="../../assets/img/qrcode-icon.png" />
                  <button
                    @click="createdQrCode(ticketDetails.content.card_pwd)"
                    class="send-to-phone"
                  >展示二维码</button>
                </div>
                <div class="show-bar-code">
                  <img alt src="../../assets/img/coupon/bar-code.png" />
                  <button
                    @click="createdBarCode(ticketDetails.content.card_pwd)"
                    class="send-to-phone"
                  >展示条形码</button>
                </div>
              </div>
              <div class="bar-code" v-show="!QRCode">
                <svg id="barCode" />
              </div>
              <div class="qrcode" v-show="QRCode">
                <img :src="QRCode" alt id="QrCode" />
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- 带密码卡券 -->
          <div class="list" v-if="ticketDetails.content.card_no">
            <div class="desc">
              <div class="intro">
                <span>账号:</span>
                <em>{{ticketDetails.content.card_no}}</em>
              </div>

              <button
                :data-clipboard-text="ticketDetails.content.card_no"
                @click="getCardsClose"
                class="copy cards-close"
              >复制</button>
            </div>
            <div class="desc">
              <div class="intro">
                <span>密码:</span>
                <em>{{ticketDetails.content.card_pwd}}</em>
              </div>
              <button
                :data-clipboard-text="ticketDetails.content.card_pwd"
                @click="getCardsClose"
                class="copy cards-close"
              >复制</button>
            </div>
          </div>
          <!-- 不带账号卡券 -->
          <div class="list" v-else>
            <div class="kami">
              <div class="kami-desc">
                <div class="intro">
                  <span>卡密:</span>
                  <em>{{ticketDetails.content.card_pwd}}</em>
                </div>
                <button
                  :data-clipboard-text="ticketDetails.content.card_pwd"
                  @click="getCardsClose"
                  class="copy cards-close"
                >复制</button>
              </div>
              <div class="show-code-button">
                <div class="show-qr-code">
                  <img alt src="../../assets/img/qrcode-icon.png" />
                  <button
                    @click="createdQrCode(ticketDetails.content.card_pwd)"
                    class="send-to-phone"
                  >展示二维码</button>
                </div>
                <div class="show-bar-code">
                  <img alt src="../../assets/img/coupon/bar-code.png" />
                  <button
                    @click="createdBarCode(ticketDetails.content.card_pwd)"
                    class="send-to-phone"
                  >展示条形码</button>
                </div>
              </div>
              <div class="bar-code" v-show="!QRCode">
                <svg id="barCode" />
              </div>
              <div class="qrcode" v-show="QRCode">
                <img :src="QRCode" alt id="QrCode" />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="functional-btn" v-if="ticketDetails.content">
        <!-- <button v-show="!ticketDetails.content.card_pwd" class="send-to-phone" @click="createdQrCode(ticketDetails.content.card_no)">生成二维码</button> -->
        <button @click="clickOverlay" class="close">关闭</button>
        <button
          @click="goUse(ticketDetails.content)"
          class="go-use"
          v-show="ticketDetails.content.code_url"
        >去使用</button>
      </div>
    </div>
  </popup>
</template>

<script>
import ClipboardJS from 'clipboard'
import JsBarcode from 'jsbarcode'
import { Popup } from 'vant'
import QRCode from 'qrcode'
export default {
  name: 'camiloDetails',
  components: {
    Popup
  },
  model: {
    prop: 'show'
  },
  props: {
    show: {
      type: Boolean
    },
    ticketDetails: {
      type: Object,
      required: true
    }
  },
  watch: {
    show (newVal) {
      this.showDetails = newVal
    },
    showDetails (newVal) {
      if (!newVal) {
        this.clickOverlay()
      } else {
        this.QRCode = ''
        if (!this.ticketDetails.content.card_no) {
          this.createdQrCode(this.ticketDetails.content.card_pwd)
        }
      }
    }
  },
  data () {
    return {
      showDetails: false,
      QRCode: ''
    }
  },
  methods: {
    clickOverlay () {
      this.$emit('close')
    },
    goUse (content) {
      if (content.code_url) {
        location.href = content.code_url
      }
    },
    getCardsClose () {
      const clipboard = new ClipboardJS('.cards-close')
      clipboard.on('success', e => {
        e.clearSelection()
        this.$toast('复制成功')
      })
      clipboard.on('error', e => {
        this.$toast('复制失败')
      })
    },
    async createdQrCode (number) {
      QRCode.toDataURL(number)
        .then(url => {
          this.QRCode = url
        })
        .catch(() => {
          this.QRCode = ''
          this.$toast('生成二维码失败')
        })
    },
    createdBarCode (code) {
      this.QRCode = ''
      JsBarcode('#barCode', code, {
        format: 'code128'
      })
    }
  }

}
</script>

<style lang="less" scoped>
.camilo-details {
  width: 6.9rem;
  min-height: 5rem;
  background-color: #fff;
  .title {
    position: relative;
    margin: 0 0.34rem;
    height: 1.4rem;
    border-bottom: 0.5px dashed #979797;
    display: flex;
    align-items: center;
    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.7);
      bottom: -0.2rem;
    }
    &::before {
      left: -0.54rem;
    }
    &::after {
      right: -0.54rem;
    }
    .icon {
      width: 0.9rem;
      height: 0.9rem;
    }
    .intro {
      height: 0.8rem;
      .flex-column-between;
      margin-left: 0.26rem;
      .name {
        font-size: 0.34rem;
        font-weight: 660;
        color: @base;
      }
      .num {
        font-size: @fz24;
        color: @c80;
      }
    }
  }
  .details {
    color: @base;
    font-size: @fz32;
    padding: 0 0.4rem;
    .tit {
      margin: 0.6rem 0 0.32rem;
    }
    .list {
      .desc {
        height: 0.96rem;
      }
      .desc,
      .kami {
        width: 6.15rem;
        .flex-between;
        background-color: #f1f1f1;
        border-radius: 0.14rem;
        margin-top: 0.37rem;
        .intro {
          padding-left: 0.21rem;
          em {
            padding-left: 0.2rem;
            color: @c80;
            color: @fz24;
          }
        }
        .copy {
          color: #ff9600;
          padding-right: 0.24rem;
        }
      }
      .kami {
        padding-bottom: 0.2rem;
        .flex-column;
        .kami-desc {
          width: 5.9rem;
          height: 0.96rem;
          .flex-between;
          border-bottom: 0.5px dashed @c80;
          margin-bottom: 0.25rem;
        }
        .show-code-button {
          padding: 0.25rem 0;
          .flex-between;
        }

        .show-qr-code,
        .show-bar-code {
          display: flex;
          align-items: center;
          img {
            width: 0.33rem;
            padding-right: 0.1rem;
          }
        }
        .show-bar-code {
          padding-left: 0.5rem;
          img {
            width: 0.4rem;
          }
        }
      }
      .qrcode {
        margin: 0.2rem auto;
        width: 3rem;
        height: 3rem;
      }
      .bar-code {
        margin: 0.2rem auto;
        max-width: 5.5rem;
        height: 3rem;
        svg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .functional-btn {
    padding: 0.1rem 0.2rem 0.47rem;
    .flex-around;
    button {
      width: 2.9rem;
      height: 0.88rem;
      border-radius: 30px;
      font-size: @fz32;
      margin-top: 0.4rem;
    }
    .send-to-phone {
      color: #fff;
      background-color: #509ffa;
    }
    .close {
      color: #6a6a6a;
      border: 0.5px solid #6a6a6a;
    }
    .go-use {
      color: #fff;
      background-color: #509ffa;
    }
  }
}
</style>
